export default __webpack_public_path__ + "static/media/default-card.347ccceb.png";